import { CardPropsI } from "./Card.props";
import cn from "classnames";
import styles from "./Card.module.scss";

function Card({
  modal,
  acc,
  className,
  children,
  refElem,
  ...props
}: CardPropsI) {
  return (
    <div
      className={cn(styles.wrapper, className, {
        [styles.modal]: modal,
        //[styles.logo]: acc,
      })}
      ref={refElem}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
